import { Session } from '../session/_types';
import { User } from '../user/_types';
import { isManager, isTrainer } from '../user/utils';

import { DNS_BLOCK_PATH } from './dnsBlock';

export function isDnsBlockStaff(user?: User | null): boolean {
  if (!user) {
    return false;
  }

  return isTrainer(user) || isManager(user);
}

export function isDnsMigrationBlocked(
  session?: Session,
  user?: User | null
): boolean {
  if (!session || !user || !isDnsBlockStaff(user)) {
    return false;
  }

  if (!session.dnsMigrationBlocked) {
    return false;
  }

  if (session.dnsBlockActivity?.snoozeActive) {
    return false;
  }

  return true;
}

export function isDnsBlockPath(pathname: string): boolean {
  const normalized = pathname.replace(/^\/ex4/, '');
  return normalized === DNS_BLOCK_PATH || normalized === `${DNS_BLOCK_PATH}/`;
}
